<template>
    <v-card
        flat
        tile
        :height="cardHeight"
        id="careers"
    >
        <v-parallax
            src="@/assets/components/careers/careers_hero_1920x1280.webp"
            style="height: 100%;"
            class="hero"
            alt="Prospira building 2 front entrance"
        >
            <v-container fill-height>
                <v-row class="hero-content">
                    <v-col cols="12" class="d-flex flex-column align-center text-center">
                        <v-img
                            src="@/assets/mark_logo.png"
                            contain
                            width="90"
                            alt="Prospira 'S' style logo"
                        ></v-img> 

                        <h3 class="text-h3 font-weight-bold mt-3 white--text">Careers</h3>

                        <h6 class="text-h6 font-weight-bold my-3 white--text">
                            At Prospira, we're proud of where we've been and where we're going.<br>
                            Our blend of passion and technological innovation is the force behind our growth.
                        </h6>

                        <navigation-button
                            slug="/careers"
                            text="Career Information"
                        ></navigation-button>

                    </v-col>
                </v-row>
            </v-container>
        </v-parallax>
    </v-card>
</template>

<script>
import NavigationButton from './global/NavigationButton.vue'

export default {
    components: {
        'navigation-button': NavigationButton
    },
    name: 'CareersHero',
    computed: {
        cardHeight() {
            return this.$vuetify.breakpoint.mdAndDown ? '80vh' : '50vh'
        }
    }
}
</script>

<style scoped>
.hero {
    width: 100%;
    position: absolute;
    background-color: white;
    opacity: 0.9;
}

.hero-content {
    z-index: 999;
}

.left-border {
    border-left: 3px solid white;
}
</style>